import React from 'react';
import { Link2, ImagePlus, Library } from 'lucide-react';
import { Modal } from '../../UI/Modal';

type ExampleWorkSource = 'upload' | 'myWorks' | 'url';

interface ExampleWorkSourceModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (source: ExampleWorkSource) => void;
    canSelectMyWorks?: boolean;
    zIndex?: number;
}

const ExampleWorkSourceModal: React.FC<ExampleWorkSourceModalProps> = ({
    isOpen,
    onClose,
    onSelect,
    canSelectMyWorks = true,
    zIndex = 70
}) => {
    const options: Array<{
        id: ExampleWorkSource;
        title: string;
        description: string;
        icon: React.ReactNode;
        disabled?: boolean;
    }> = [
        {
            id: 'upload',
            title: '本地上传',
            description: '上传图片或视频文件作为参考作品',
            icon: <ImagePlus className="w-5 h-5 text-blue-600" />
        },
        {
            id: 'myWorks',
            title: '我的作品',
            description: canSelectMyWorks ? '直接复用你已发布或保存过的作品' : '当前无法获取你的作品列表',
            icon: <Library className="w-5 h-5 text-emerald-600" />,
            disabled: !canSelectMyWorks
        },
        {
            id: 'url',
            title: '输入 URL',
            description: '支持本站作品链接，或可直接访问的图片/视频链接',
            icon: <Link2 className="w-5 h-5 text-violet-600" />
        }
    ];

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="添加参考作品"
            size="lg"
            zIndex={zIndex}
        >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {options.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        disabled={option.disabled}
                        onClick={() => onSelect(option.id)}
                        className={`rounded-2xl border p-5 text-left transition-all ${option.disabled
                            ? 'border-gray-100 bg-gray-50 text-gray-400 cursor-not-allowed'
                            : 'border-gray-200 bg-white hover:border-black hover:shadow-lg'
                            }`}
                    >
                        <div className="w-11 h-11 rounded-full bg-gray-50 flex items-center justify-center mb-4">
                            {option.icon}
                        </div>
                        <h4 className="text-base font-semibold text-gray-900">{option.title}</h4>
                        <p className={`mt-2 text-sm leading-6 ${option.disabled ? 'text-gray-400' : 'text-gray-500'}`}>
                            {option.description}
                        </p>
                    </button>
                ))}
            </div>
        </Modal>
    );
};

export default ExampleWorkSourceModal;
